import { Dropdown } from "react-bootstrap";
import messages from "../views/MessageCenter/MessageCenter.messages";
import React from "react";
import PropTypes from "prop-types";
import { injectIntl } from "react-intl";

const MessageSortDropdown = (props) => {
    const lng = props.intl.formatMessage;
    
    return (
        <Dropdown>
            <Dropdown.Toggle className="dropdown-toggle-white">
                {lng(messages.sortDropdownToggle)}
            </Dropdown.Toggle>
            <Dropdown.Menu>
                <Dropdown.Item
                    className={'dropdown-check-item' + (props.sortOption === 'newest' ? ' active' : '')}
                    onClick={() => { props.onSortChange('newest'); }}
                >
                    {lng(messages.sortNewestFirst)}
                </Dropdown.Item>
                <Dropdown.Item
                    className={'dropdown-check-item' + (props.sortOption === 'unread' ? ' active' : '')}
                    onClick={() => { props.onSortChange('unread'); }}
                >
                    {lng(messages.sortUnread)}
                </Dropdown.Item>
                <Dropdown.Item
                    className={'dropdown-check-item' + (props.sortOption === 'status' ? ' active' : '')}
                    onClick={() => { props.onSortChange('status'); }}>
                    {lng(messages.sortByStatus)}
                </Dropdown.Item>
                <Dropdown.Item
                    className={'dropdown-check-item' + (props.sortOption === 'creditor' ? ' active' : '')}
                    onClick={() => { props.onSortChange('creditor'); }}
                >
                    {lng(messages.sortByCreditorName)}
                </Dropdown.Item>
            </Dropdown.Menu>
        </Dropdown>        
    )
}


MessageSortDropdown.propTypes = {
    'intl': PropTypes.object.isRequired,
    'sortOption': PropTypes.string.isRequired,
    'onSortChange': PropTypes.func.isRequired
}

export default injectIntl(MessageSortDropdown);
